import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';

export interface SecondaryContent {
  content: string;
  style: { [key: string]: string };
}

/**
 * Interfaces dialog modal data
 * @param {string} title string?
 * @param {string} content string?
 * @param {SecondaryContent[]} secondaryContent SecondaryContent[]?
 * @param {string} successButtonText string?
 * @param {string} deleteButtonText string?
 * @param {string} failButtonText string?
 * @param {boolean} contentKeepWhiteSpace boolean?
 */
export interface DialogModalData {
  title?: string;
  content?: string;
  secondaryContent?: SecondaryContent[];
  successButtonText?: string;
  deleteButtonText?: string;
  failButtonText?: string;
  contentKeepWhiteSpace?: boolean;
}

@Component({
  selector: 'app-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Modal molecule
 */
export class DialogModalComponent {
  /**
   * @constructor
   */
  constructor(
    private dialogRef: MatDialogRef<DialogModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModalData
  ) {}

  /**
   * Action to close the dialog
   */
  onSuccessClick() {
    this.dialogRef.close(MatDialogResponse.SUCCESS);
  }

  /**
   * Action to close the dialog
   */
  onFailClick() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }

  /**
   * If whitespace should be kept (pre) in dialog content
   */
  get contentKeepWhiteSpace() {
    return Boolean(this.data.contentKeepWhiteSpace);
  }
}
